








































































import store from '@/store'
import ApiClient from '@/js/api.js'
import Global from '@/js/global.js'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import ManageSubTitle from '@/views/atoms/ManageSubTitle.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import OrderHistoryItem from '@/views/organisms/OrderHistoryItem.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'

export default
  name: 'MyPage'

  components: {
    Pankuzu
    Title
    ManageSubTitle
    ManageBase
    OrderHistoryItem
    ManageTemplate
    YellowButton
    BackButton
  }

  data: ()->
    detail: {}

  created: () ->
    store.dispatch('initPostParam')
    @$emit('set_color', true)

    api = new ApiClient()
    data = await api.get('/member/purchase_history/detail/' + @$route.query.id)
    @detail = data.detail

  methods: {
    go_back: () ->
      url = store.getters.backURL
      if url
        @$router.push store.getters.backURL
      else
        @$router.push '/mypage/order_history'
    total_price: () ->
      return @tax(@detail.total_price) +
          parseInt(@detail.total_send_price, 10) +
          parseInt(@detail.other_price) -
          parseInt(@detail.coupon_price)
    state_name: (state) ->
      if state == '0'
        return '未発送'
      if state == '1'
        return '一部発送済み'
      if state == '2'
        return '発送済み'
    pay_name: (id) ->
      for key, row of Global.getPayStyles()
        if key == id
          return row
      return ''
    tax: (price) ->
      Global.tax(price)
    comma: (price) ->
      Global.comma(price)
  }

